import groq from 'groq';

export const watchPlaceQuery = groq`*[_type == "foodPlace" && _id == $placeId || _type == "menu" && _id in $menuIds]`;
